import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { typographyTemplate } from '@equinor/eds-utils';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Divider } from '../Divider/Divider.js';

var _excluded = ["children", "scrollable"];
var StyledDialogContent = styled.div.withConfig({
  displayName: "DialogContent__StyledDialogContent",
  componentId: "sc-1tze18k-0"
})(function (_ref) {
  var theme = _ref.theme,
    $scrollable = _ref.$scrollable;
  return css(["--content-spacing-top:", ";", " min-height:", ";align-self:stretch;justify-self:stretch;padding:0 ", " 0 ", ";&:first-child{padding-top:var(--content-spacing-top);}&:last-child{padding-bottom:", ";}", ""], theme.entities.children.spacings.top, typographyTemplate(theme.entities.content.typography), theme.entities.content.minHeight, theme.entities.children.spacings.right, theme.entities.children.spacings.left, theme.entities.children.spacings.bottom, $scrollable && css(["&:not(:first-child){margin-top:calc(var(--content-spacing-top) * -1);}padding-top:var(--content-spacing-top);margin-bottom:calc(var(--content-spacing-top) * -1);padding-bottom:var(--content-spacing-top);min-height:initial;height:", ";overflow-y:auto;"], theme.entities.content.height));
});
var StyledDivider = styled(Divider).withConfig({
  displayName: "DialogContent__StyledDivider",
  componentId: "sc-1tze18k-1"
})(["width:100%;margin:0;"]);
var DialogContent = /*#__PURE__*/forwardRef(function DialogContent(_ref2, ref) {
  var children = _ref2.children,
    _ref2$scrollable = _ref2.scrollable,
    scrollable = _ref2$scrollable === void 0 ? false : _ref2$scrollable,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var props = _objectSpread({
    $scrollable: scrollable,
    ref: ref
  }, rest);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(StyledDialogContent, _objectSpread(_objectSpread({
      id: "eds-dialog-customcontent"
    }, props), {}, {
      children: children
    })), children && scrollable && /*#__PURE__*/jsx(StyledDivider, {
      color: "medium",
      variant: "small"
    })]
  });
});

export { DialogContent };
